import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
    const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
    return {
        Authorization: `Bearer ${tokenData.accessToken}`,
        'Content-Type': 'application/json'
    };
};

export const getPendingBilledServicesReport = async (filter) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/Booking/report-pending-billed-services`, filter, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching pending billed services report:", error);
        throw error;
    }
};
